import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M7.25 4A2.756 2.756 0 0 1 10 1.25h10A2.756 2.756 0 0 1 22.75 4v10A2.756 2.756 0 0 1 20 16.75a.75.75 0 0 1 0-1.5c.686 0 1.25-.564 1.25-1.25V4c0-.686-.564-1.25-1.25-1.25H10c-.686 0-1.25.564-1.25 1.25a.75.75 0 0 1-1.5 0m-6 6A2.75 2.75 0 0 1 4 7.25h10A2.75 2.75 0 0 1 16.75 10v10A2.75 2.75 0 0 1 14 22.75H4A2.75 2.75 0 0 1 1.25 20zM4 8.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10c0-.69-.56-1.25-1.25-1.25z"
      clipRule="evenodd"
    />
  </>
);

const Copy = Icon('copy', svgContents);

export default Copy;
